import type { IconData } from '@stacksjs/iconify-core'

export const basicUiAdd2: IconData = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M8 16A8 8 0 1 0 8 0a8 8 0 0 0 0 16M6.5 6.5V4h3v2.5H12v3H9.5V12h-3V9.5H4v-3z\" clip-rule=\"evenodd\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "0 0 24 24"
}

export default basicUiAdd2
